import XLSX from 'xlsx';

const PRODUCT_GROUP_CODES = [
    'ALCOHOL',
    'BIOFUELS',
    'COFFEE',
    'DRINKS',
    'FUEL',
    'MEDICATIONS',
    'TOBACCO',
    'VETERINARY',
];

const getFileType = (ws: XLSX.WorkSheet) => {
    const legacyFileType = ws.X1?.v;
    if (legacyFileType) return legacyFileType;

    const headerRows = XLSX.utils.sheet_to_json(ws, {
        header: 1,
        range: 0,
        defval: '',
    }) as string[][];
    const headerFileType = headerRows[0]?.find((value) =>
        PRODUCT_GROUP_CODES.includes(
            String(value)
                .trim()
                .toUpperCase(),
        ),
    );

    return headerFileType ? String(headerFileType).trim() : undefined;
};

export const readXlsxProducts = (
    file: any,
    callback: any,
): {
    file: File | null;
    extension: string;
} => {
    const extensionArr = file?.name?.split('.');
    const extension = extensionArr ? extensionArr[extensionArr.length - 1] : null;
    const reader = new FileReader();
    reader.onload = (evt) => {
        const bstr = evt?.target?.result;
        const wb = XLSX.read(bstr, {type: 'binary'});
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];

        const range = {s: {c: 0, r: 0}, e: {c: 0, r: 0}};
        Object.keys(ws)
            .filter((k) => k[0] !== '!')
            .forEach((k) => {
                const cell = XLSX.utils.decode_cell(k);
                if (cell.r > range.e.r) range.e.r = cell.r;
                if (cell.c > range.e.c) range.e.c = cell.c;
            });
        ws['!ref'] = XLSX.utils.encode_range(range);

        const file_type = getFileType(ws);

        const data = XLSX.utils.sheet_to_json(ws, {header: 1, range: 2, defval: ''}) as string[][];

        const data_without_empty_rows = data.filter((item) => !item.every((i) => i === ''));
        callback(data_without_empty_rows, file, file_type);
    };
    file && reader.readAsBinaryString(file);

    return {
        file,
        extension,
    };
};
